module.exports = __webpack_public_path__ + "img/signin-logo.ae10b56.svg";